export const COMPANY_OWNER = 'company_owner';
export const COMPANY_MANAGER = 'company_manager';
export const COMPANY_GRANTS = 'company_grants';


class Auth {

    constructor(user) {
        this.user = user;
        if(user) {
            this.permissions = this.getPermissions();
        }
    }

    getPermissions() {
        let permissions = [];

        this.user.roles.forEach((item, index) => {
            item.permissions.forEach((permission, index) => {
               permissions.push(permission.name);
            });
        });

        return permissions;
    }

    hasOneOfPermissions(names = []) {
        for (let i = 0; i < names.length; i++) {
            if(_.findIndex(this.permissions, p => {
                return p === names[i];
            }) !== -1) {
                return true;
            }
        }

        return false;
    }

    hasPermission(name) {

        const index = _.findIndex(this.user.permissions, permission => {

           return permission.name === name;
        });

        return index !== -1;
    }




}


export  default new Auth(window.user);
